import CustomRoute from "components/ui/customs/routes/CustomRoute";
import myOfficeConfig from "./myOfficeConfig";

const MyOfficeRoutes = CustomRoute(myOfficeConfig);

export default MyOfficeRoutes;
